import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Layout & Common
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";

// Page components
import Header from "layouts/profile/components/Header";
import UpdatePasswordModal from "./components/UpdatePasswordModal";
import { ImageUpload } from "store/slice/usersSlice";
import ImageUploadModal from "./components/ImageUploadModal";
import AccountDetails from "./components/AccountDetails";

function Overview() {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={3}>
            {/* Left Column */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <MDBox p={3} sx={{ border: "1px solid #e0e0e0", borderRadius: "12px" }}>
                <MDTypography variant="h6" gutterBottom>
                  Change Account Details
                </MDTypography>
                <AccountDetails />
              </MDBox>
            </Grid>

            {/* Right Column */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <MDBox p={3} sx={{ border: "1px solid #e0e0e0", borderRadius: "12px" }}>
                <MDTypography variant="h6" gutterBottom>
                  Change Password & Profile Image
                </MDTypography>

                <MDBox mt={2}>
                  <Button variant="contained" color="primary" onClick={() => setPasswordModalOpen(true)} sx={{ mr: 2 }}>
                    Change Password
                  </Button>

                  <Button variant="text" onClick={() => setImageModalOpen(true)}>
                    Upload Profile Image
                  </Button>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Header>

      <Footer />

      {/* Password Modal */}
      <UpdatePasswordModal 
        setPasswordModalOpen={setPasswordModalOpen}
        passwordModalOpen={passwordModalOpen}
      />

      {/* Image Modal */}
      <ImageUploadModal 
        imageModalOpen={imageModalOpen}
        setImageModalOpen={setImageModalOpen}
      />
    </DashboardLayout>
  );
}

export default Overview;
